import React from 'react';
import { PaymentTransaction } from '../../../api/superAdminPayments/paymentsService';
import TransactionTable from '../../../components/TransactionTable';

interface PaymentsTableProps {
  transactions: PaymentTransaction[];
  loading: boolean;
  onViewTransaction: (transaction: PaymentTransaction) => void;
  showActions?: boolean;
}

const PaymentsTable: React.FC<PaymentsTableProps> = ({ 
  transactions, 
  loading, 
  onViewTransaction,
  showActions = true
}) => {
  return (
    <TransactionTable
      transactions={transactions}
      loading={loading}
      onViewTransaction={onViewTransaction}
      showActions={showActions}
      showHeader={false}
      isDashboard={false}
    />
  );
};

export default PaymentsTable; 